module.exports = __webpack_public_path__ + "static/media/134.671c9250.webp";